/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {initiateRemoteCheckDeposit} from '../api'

export const useMutationInitiateRemoteCheckDeposit = createReactQueryMutationHook('initiateRemoteCheckDeposit', initiateRemoteCheckDeposit)
